'use client';

import React, { useState, useEffect } from 'react';
import {
    FeaturedPostVariantA,
    FeaturedPostVariantB,
    FeaturedPostVariantD,
    FeaturedPostLayout1,
    FeaturedPostLayout2,
    FeaturedPostLayout3
} from './FeaturedPostVariants';

const VARIANT_KEYS = ['A', 'B', 'D', 'layout1', 'layout2', 'layout3'];

const FeaturedPost = ({ post, recentPosts = [] }) => {
    const [variant, setVariant] = useState(null);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        // Randomly select a layout on mount
        const randomVariant = VARIANT_KEYS[Math.floor(Math.random() * VARIANT_KEYS.length)];
        setVariant(randomVariant);
        setMounted(true);
    }, []);

    if (!post) return null;

    // Map keys to components
    const LayoutComponents = {
        'A': FeaturedPostVariantA,
        'B': FeaturedPostVariantB,
        'D': FeaturedPostVariantD,
        'layout1': FeaturedPostLayout1,
        'layout2': FeaturedPostLayout2,
        'layout3': FeaturedPostLayout3
    };

    if (!mounted) {
        // Default to Variant A for SSR
        return <FeaturedPostVariantA post={post} />;
    }

    const SelectedLayout = LayoutComponents[variant] || FeaturedPostVariantA;

    return <SelectedLayout post={post} recentPosts={recentPosts} />;
};

export default FeaturedPost;
